// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_container__3Z5c5","submitButton":"auth_submitButton__1PG2_","card":"auth_card__3eeQ0","gridMargin":"auth_gridMargin__1e-zf"};